<template>
  <select @change="changeLang($event)" class="selectpicker form-control" id="lang-picker" data-width="fit">
    <option value="pt" :selected="this.$i18n.locale == 'pt' ? true : false" data-content='<span class="flag-icon flag-icon-pt"></span> PT'> PT</option>
    <option value="en" :selected="this.$i18n.locale == 'en' ? true : false" data-content='<span class="flag-icon flag-icon-gb"></span> EN'> EN</option>
  </select>
</template>

<script>
export default {
  name: 'SelectLanguage',
  data() {
    return {
      weekdays: {
        en: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        pt: ["Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"]
      },
      months: {
        en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        pt: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
      },
      shortMonths: {
        en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        pt: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
      }
    }
  },
  mounted(){
    $("#lang-picker").selectpicker()
  },
  computed: {
    current_page: function(){
      return this.$route.name
    }
  },
  methods: {
    changeLang: function(event){
      if(event.target.value == 'pt' || event.target.value == 'en'){
        this.$i18n.locale = event.target.value
        _paq.push(['trackEvent', this.current_page, 'Idioma', event.target.value])
        this.setLanguage()
      } 
    },
    setLanguage: function(){
      window.moment.updateLocale(this.$i18n.locale, {
        weekdays: this.weekdays[this.$i18n.locale]
      })

      window.moment.locale(this.$i18n.locale)
      moment.locale(this.$i18n.locale)

      Highcharts.setOptions({ 
        lang: { 
          weekdays: this.weekdays[this.$i18n.locale],
          shortMonths: this.shortMonths[this.$i18n.locale],
          months: this.months[this.$i18n.locale],
          noData: this.$i18n.t('No_Data'), 
          loading: this.$i18n.t('Loading')
        } 
      })
      
      $('[data-toggle="tooltip"]').tooltip('dispose')
      this.$nextTick(() => { 
        $('[data-toggle="tooltip"]').tooltip() 
      })
      
      if(this.$route.meta.name_to_translate)
        document.title = "SMILE | "+this.$i18n.t(this.$route.meta.name_to_translate)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
